module.exports = __webpack_public_path__ + "img/ico-caret-left-white.a4e543f1.svg";